//USERINFO
const flipmeUser = localStorage.getItem('flipme-user')
  ? JSON.parse(localStorage.getItem('flipme-user') || '')
  : null;

//TOKENS
const tokens = localStorage.getItem('flipme-token')
  ? JSON.parse(localStorage.getItem('flipme-token') || '')
  : null;

export const preloadedState = {
  user: flipmeUser,
  tokens,
};
